import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        vista: "detalle",
        carrerasBuscadas: [],
        busquedasAplicadas: [],
        areasCarrerasInstituciones: [],
        dataSimulacion: {},
        areaConocimientoSeleccionada: null,
        carreraGenericaSeleccionada: null,
        institucionSeleccionada: null,
        regionSeleccionada: null,
        nombreCarreraSeleccionada: "",
        jornada: null,
        criterioOrden: null,
        botonCaptcha: ""
    },
    getters: {
        getCarreras(state) {
            return state.carrerasBuscadas;
        },
        getBusquedasAplicadas(state) {
            return state.busquedasAplicadas;
        },
        getFiltroABorrar(state) {
            return state.filtroABorrar;
        },
        getAreasCarrerasInstituciones(state) {
            return state.areasCarrerasInstituciones;
        },
        getAreaConocimientoSeleccionada(state) {
            return state.areaConocimientoSeleccionada;
        },
        getCarreraGenericaSeleccionada(state) {
            return state.carreraGenericaSeleccionada;
        },
        getInstitucionSeleccionada(state) {
            return state.institucionSeleccionada;
        },
        getRegionSeleccionada(state) {
            return state.regionSeleccionada;
        },
        getNombreCarreraSeleccionada(state) {
            return state.nombreCarreraSeleccionada;
        },
        getCriterioOrden(state) {
            return state.criterioOrden;
        },
        getJornada(state) {
            return state.jornada;
        },
        getDataSimulacion(state) {
            return state.dataSimulacion;
        },
        getBotonCaptcha(state) {
            return state.botonCaptcha;
        }
    },
    actions: {
        setVista({ commit }, payload) {
            commit("cambiarVista", payload);
        },
        setCarreras({ commit }, payload) {
            commit("guardarCarreras", payload);
        },
        setBusqueda({ commit }, payload) {
            commit("cambiarBusquedas", payload);
        },
        setAreasCarrerasInstituciones({ commit }, payload) {
            commit("cambiarAreasCarrerasInstituciones", payload);
        },
        setAreaConocimientoSeleccionada({ commit }, payload) {
            commit("cambiarAreaConocimiento", payload)
        },
        setCarreraGenericaSeleccionada({ commit }, payload) {
            commit("cambiarCarreraGenerica", payload)
        },
        setInstitucionSeleccionada({ commit }, payload) {
            commit("cambiarInstitucion", payload)
        },
        setJornada({ commit }, payload) {
            commit("cambiarJornada", payload)
        },
        clearSeleccionados({ commit }) {
            commit("cambiarRegion", null)
            commit("cambiarNombreCarrera", "")
            commit("cambiarAreaConocimiento", null)
            commit("cambiarCarreraGenerica", null)
            commit("cambiarInstitucion", null)
            commit("cambiarCriterioOrden", null)
            commit("cambiarJornada", null)
        },
        setRegionSeleccionada({ commit }, payload) {
            commit("cambiarRegion", payload)
        },
        setNombreCarreraSeleccionada({ commit }, payload) {
            commit("cambiarNombreCarrera", payload)
        },
        setCriterioOrden({ commit }, orden) {
            commit("cambiarCriterioOrden", orden)
        },
        setSimulacion({ commit }, simulacion) {
            commit("guardarSimulacion", simulacion)
        },
        setBotonCaptcha({ commit }, boton) {
            commit("guardarBoton", boton)
        }
    },
    mutations: {
        cambiarVista(state, vista) {
            state.vista = vista;
        },
        guardarCarreras(state, carrerasBuscadas) {
            state.carrerasBuscadas = carrerasBuscadas;
        },
        cambiarBusquedas(state, busquedas) {
            state.busquedasAplicadas = [...busquedas];
        },
        cambiarAreasCarrerasInstituciones(state, payload) {
            state.areasCarrerasInstituciones = [...payload];
        },
        cambiarAreaConocimiento(state, area) {
            state.areaConocimientoSeleccionada = area
        },
        cambiarCarreraGenerica(state, carreraGen) {
            state.carreraGenericaSeleccionada = carreraGen
        },
        cambiarInstitucion(state, instituto) {
            state.institucionSeleccionada = instituto
        },
        cambiarRegion(state, region) {
            state.regionSeleccionada = region
        },
        cambiarNombreCarrera(state, nombreCarrera) {
            state.nombreCarreraSeleccionada = nombreCarrera
        },
        cambiarJornada(state, jornada) {
            state.jornada = jornada
        },
        cambiarCriterioOrden(state, orden) {
            state.criterioOrden = orden
        },
        guardarSimulacion(state, simulacion) {
            state.dataSimulacion = simulacion
        },
        guardarBoton(state, boton) {
            state.botonCaptcha = boton
        }
    }
});

export default store;


// WEBPACK FOOTER //
// ./src/store/store.js